const SET_CAP_HISTORICAL_NOTICES = 'SET_CAP_HISTORICAL_NOTICES';
const RESET_CAP_HISTORICAL_NOTICES = 'RESET_CAP_HISTORICAL_NOTICES';

export const CAP_HISTORICAL_NOTICES_ACTION_TYPES = {
    SET_CAP_HISTORICAL_NOTICES,
    RESET_CAP_HISTORICAL_NOTICES,
};
